import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../redux/configureStore';
import { getCashInDataExcel } from '../../../../../../redux/fetchActions/legadoPage/cashinReportApp';
import SearchButton, {
  Loading,
} from '../../../../../../shared/components/buttons/SearchButton';
import Wrapper from '../../../../../../shared/components/Wrapper';
import SetPartner from '../AccountingFilter/components/SetPartner';
import SetMonthEnd from './FilterModal/components/SetMonthEnd';
import SetMonthInitial from './FilterModal/components/SetMonthInitial';

export default function analyticReportCsv({ show, onHide }) {
  const dispatch = useDispatch();
  const [initial, setInitial] = useState('');
  const [end, setEnd] = useState('');
  const [type] = useState('analitico');
  const [partner, setPartner] = useState('1');

  const downloadContext = useSelector(
    (reducer: IReducer) => reducer.cashInDownload
  );

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      style={{
        borderRadius: '10px 10px 0px 0px',
        display: 'block',
        maxWidth: '550px',
        margin: 'auto',
        left: '50%',
        transform: 'translate(-50%,0%)',
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header
        style={{
          background: '#125C5B',
          color: '#fff',
          fontStyle: 'normal',
          display: 'flex',
          justifyContent: 'center',
        }}>
        <Modal.Title
          style={{
            fontSize: '22px',
            lineHeight: '26px',
            textAlign: 'center',
            fontWeight: 'bold',
          }}
          id="contained-modal-title-vcenter">
          Download do relatório análitico em Excel
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Wrapper.Default isActive flexDirection="column">
          <Wrapper.Default isActive flexDirection="row">
            <SetPartner orientation="column" set={setPartner} info={partner} />
            <SetMonthInitial setDate={setInitial} date={initial} />
            <SetMonthEnd setDate={setEnd} date={end} />
          </Wrapper.Default>
        </Wrapper.Default>
      </Modal.Body>
      <Modal.Footer
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          border: 'none',
        }}>
        <Wrapper.Button onClick={onHide}>Fechar</Wrapper.Button>
        {downloadContext.isLoading ? (
          <Loading justifyContent="center" width="10rem" />
        ) : (
          <SearchButton
            onClick={() => {
              dispatch(getCashInDataExcel(initial, end, type, partner));
            }}
            justifyContent="center"
            width="10rem"
          />
        )}
      </Modal.Footer>
    </Modal>
  );
}
